export const ChevronRight = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.542893 2.20711C0.152369 1.81658 0.152369 1.18342 0.542893 0.792893C0.933418 0.402369 1.56658 0.402369 1.95711 0.792893L7.45711 6.29289C7.84763 6.68342 7.84763 7.31658 7.45711 7.70711L1.95711 13.2071C1.56658 13.5976 0.933418 13.5976 0.542893 13.2071C0.152369 12.8166 0.152369 12.1834 0.542893 11.7929L5.33579 7L0.542893 2.20711Z"
      fill="currentColor"
    />
  </svg>
);
